import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import Validators from '../validators'
import createSubentityConfs from './subentity'
import { BaseManipStateFn, BaseTableState } from '../base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    onSaved (saved) {
      store.markDirty('rights')
      store.markDirty('access_rights')
      super.onSaved(saved)
    }

    save () {
      const isEntityEdit = (store.router.queryParams &&
        store.router.queryParams.hasOwnProperty('type') &&
        store.router.queryParams['type'] === 'entity')

      if (isEntityEdit) {
        this.state = 'saving'
        const changes = this.record.get('changes')
        const allRights = store.options.get('access_rights')
        const toSave = []
        changes.forEach(i => {
          if (!toSave.find(user => user.uid === changes.uid)) {
            const userRights = allRights.filter(j => j.uid === i.uid)
            toSave.push({ id: i.user_access_id, uid: i.uid, user_access_rights: JSON.parse(JSON.stringify(userRights)) })
          }
        })

        const promises = []
        toSave.map(record => {
          promises.push(this.saveEntry(this.entityname, record, record.id)
            .then(this.onSaved.bind(this))
            .catch(this.onError.bind(this))
          )
        })
        return Promise.all(promises).then(() => {
          store.skipWarning = true
          return true
        }).catch(store.onRequesterError.bind(store))
      } else {
        return super.save()
      }
    }

    prepareNew () {
      this.record.set('user_access_rights', [])
    }

    rightsForEntity () {
      const entname = this.store.router.params.entname
      const eid = this.store.router.params.id
      this.store.goTo(linkConst.LINK_RIGHTS, { entname, eid, id: '_new' })
    }

    createtitle = store.__(linkConst.LINK_RIGHTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_RIGHTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    subentities = createSubentityConfs(store)
    validators = {
      'uid': (store.router.queryParams &&
        store.router.queryParams.hasOwnProperty('type') &&
        store.router.queryParams['type'] === 'entity') ? [] : [
          Validators.isMandatory(store),
          Validators.isEmail(store),
          Validators.maxLength(store, 64),
          val => {
            if (!store.cv.record.has('id') && store.options.get('rights').find(r => r.uid === val)) {
              return ('This email is already is use. ')
            }
          }
        ],
      '_global': (vals, errors) => {
        const isEntityEdit = (store.router.queryParams &&
          store.router.queryParams.hasOwnProperty('type') &&
          store.router.queryParams['type'] === 'entity')

        if (isEntityEdit) {
          if (!vals.has('entityEdit') || !vals.has('entity') || !vals.get('entity')) {
            vals.set('entityEdit', true)
            return ['Select an entity from the above selection']
          }
        } else {
          if (vals && vals.get('uid')) {
            vals.set('uid', vals.get('uid').toLowerCase().replace(/\s+/g, ''))
          }
          if (!vals.has('id')) {
            if (!vals.has('user_access_rights')) {
              vals.set('user_access_rights', [])
              return ['Select at least one right for the new user']
            } else {
              if (!vals.get('user_access_rights').some(r => r.typ !== '')) {
                return ['Select at least one right for the new user']
              }
            }
          }
        }
      }
    }
    requiredOptions = [
      ['rights', '/rights?attrs=["id", "uid"]', 'uid'],
      ['access_rights', '/rights/access/all?attrs=["id", "uid", "typ", "entity"]', 'uid']
    ]
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'uid'
    ]
    headertitles = [
      store.__('ID'), store.__('UID (email)')
    ]
    defaultSort = {
      _sortField: 'id',
      _sortDir: 'ASC'
    }    
    title = store.__('rights')
  }

  return { ManipState, TableState }
}
